module.exports = require("lodash/isObject");


//////////////////
// WEBPACK FOOTER
// external "lodash/isObject"
// module id = 68
// module chunks = 0